<template>
  <div class="MessageTemplate">
    <div class="leftColumn">
      <div class="sendEmailSmsWrapper" v-if="emailService || smsService">
        <div class="labelWrap">
          <p>SEND AS</p>
        </div>
        <div class="emailSmsMessageWrapper">
          <select name="emailSmsMessage" v-model="messageType">
            <option value="SMS" v-if="smsService">SMS</option>
            <option value="E-MAIL" v-if="emailService">E-MAIL</option>
          </select>
        </div>
      </div>
      <hash-codes-list
        templateType="checkin"
        :extendWidth="true"
      ></hash-codes-list>
    </div>
    <div class="rightColumn">
      <div class="smsWrapper extendHeight" v-if="messageType === 'SMS'">
        <div class="labelWrap">
          <p>TEMPLATE</p>
        </div>
        <textarea
          type="text"
          v-model="smsMessage"
          placeholder="Type your message here."
        />
      </div>
      <div class="sendEmailSmsWrapper" v-if="messageType === 'SMS'">
        <div class="labelWrap">
          <p>SMS INFORMATION:</p>
        </div>
        <div class="charInformation">
          <p>Characters: {{ messageLength }}</p>
          <p>Messages: {{ Math.ceil(messageLength / 160) }}</p>
        </div>
      </div>
      <div class="sendEmailSmsWrapper" v-if="messageType === 'E-MAIL'">
        <div class="labelWrap">
          <p>SUBJECT</p>
        </div>
        <div class="subjectInput">
          <input
            class="form-control"
            v-model="emailSubject"
            placeholder="Type your subject here."
          />
        </div>
      </div>
      <div class="emailWrapper extendHeight" v-if="messageType === 'E-MAIL'">
        <div class="labelWrap hideElement">
          <p>TEMPLATE</p>
        </div>
        <div class="tinyEditor">
          <HtmlEditor
            v-if="editorActive"
            v-model="emailMessage"
            api-key="o8eqr3asmep3tnky3mpofyp8062atqx826sxagxm6xq3a7c2"
            :init="{
              selector: 'imgTest',
              plugins: 'link lists hr code table',
              branding: false,
              menubar: false,
              toolbar:
                'formatselect forecolor bold italic fontsizeselect | bullist numlist alignleft aligncenter alignright alignjustify link hr removeformat code table imgBtn',
              fontsize_formats: '8pt 11pt 10pt 12pt 14pt 18pt 24pt 36pt',
              height: '100%',
              resize: true,
              setup: function (editor) {
                editor.ui.registry.addButton('imgBtn', {
                  text: 'Image',
                  onAction: function () {
                    hideToolbar();
                    showImageModal = true;
                  },
                });
              },
            }"
          />
          <ImageManager
            v-if="showImageModal"
            :isModal="true"
            @changed="onSelectedImage"
            @close="(showImageModal = false), showToolbar()"
          />
        </div>
      </div>
    </div>
    <transition name="fadeInModal">
      <approve-modal
        @yes="sendMultimessage"
        @no="cancelMessageSending"
        :confirmMultiMessage="true"
        v-if="showApproveModal"
      >
        <p slot="text">Are you sure to send this message?</p>
        <p slot="sendingInformation" v-if="messageType === 'E-MAIL'">
          <span
            style="
              font-weight: bold;
              margin-right: 15px;
              margin-bottom: 20px;
              display: block;
            "
            >PLEASE NOTE: </span
          >{{ selectedGuestsWithEmails.length }} out of
          {{ selectedGuestsArray.length }} selected rooms has E-mail addresses
        </p>
        <p slot="sendingInformation" v-else>
          <span
            style="
              font-weight: bold;
              margin-right: 15px;
              margin-bottom: 20px;
              display: block;
            "
            >PLEASE NOTE: </span
          >{{ selectedGuestsWithNumbers.length }} out of
          {{ selectedGuestsArray.length }} selected rooms has Mobile numbers
        </p>
      </approve-modal>
    </transition>
    <transition name="fadeInModal" mode="out-in">
      <message-archive
        v-if="showArchive"
        @closeArchiveModal="closeArchiveModal"
        @populateContent="useContent"
      ></message-archive>
    </transition>
    <transition name="fadeInModal" mode="out-in">
      <message-scheduler
        v-if="showSchedulerModal"
        :messageContent="correctMessageContent"
        :emailSubject="emailSubject"
        :messageType="messageType"
        :manualRoomSelection="manualRoomsList"
        :selectionType="selectionType"
        @schedulerEvent="schedulderModal"
      ></message-scheduler>
    </transition>
    <success-modal
      title="YOUR MESSAGE HAS BEEN SENT"
      @successEventPassed="closeModal"
      v-if="messageSuccessModal"
      :applyBackdrop="true"
    ></success-modal>
    <fetching-loader
      displayType="displayFixed"
      v-if="sendingMultiMessages"
    ></fetching-loader>
  </div>
</template>

<script>
import HashCodesList from "@/components/WIPComponents/HashCodesList";
import SuccessModal from "@/components/GlobalComponents/SuccessModal";
import FetchingLoader from "@/components/GlobalComponents/FetchingLoader";
import ApproveModal from "@/components/GlobalComponents/ApproveModal";
import ImageManager from "@/components/MediaPage/MediaImages";
import MessageArchive from "./MultiMessageArchive";
import MessageScheduler from "./MultiMessageScheduler";
import HtmlEditor from "@/components/GlobalComponents/HtmlEditor";
import bus from "@/bus.js";
import { db, firestore } from "@/firebase";
import returnUTCTimeMixin from "@/mixins/returnUTCTimeMixin";

export default {
  name: "MultiMessageTemplates",
  components: {
    HashCodesList,
    SuccessModal,
    FetchingLoader,
    MessageArchive,
    MessageScheduler,
    ImageManager,
    ApproveModal,
    HtmlEditor,
  },
  mixins: [returnUTCTimeMixin],
  props: {
    addToArchive: {
      type: Boolean,
    },
    sendMessage: {
      type: Boolean,
    },
    archiveModalActive: {
      type: Boolean,
    },
    showSchedulerModal: {
      type: Boolean,
    },
    selectedGuestsArray: {
      type: Array,
    },
    selectionType: {
      type: String,
    },
  },
  data() {
    return {
      showImageModal: false,
      showApproveModal: false,
      showArchive: false,
      editorActive: false,
      messageSuccessModal: false,
      sendingMultiMessages: false,
      smsService: true,
      emailService: true,
      smsMessage: `Hi ##firstname##,

Visit your guestbook and find out what we have planned for you this evening!

See your guestbook here:

##link##`,
      emailSubject: "Exclusive offers today!",
      emailMessage:
        "<p>Hi ##firstname##,</p>\n<p>Visit your guestbook and find out what we have planned for you this evening!</p>\n<p>See your guestbook here:&nbsp;</p>\n<p>##link##</p>",
      messageType: "SMS",
    };
  },
  watch: {
    addToArchive(newValue) {
      if (newValue) {
        this.addToPermanentArchive();
      }
    },
    sendMessage(newValue) {
      if (newValue) {
        this.showApproveModal = true;
      }
    },
    archiveModalActive(newValue) {
      if (newValue) {
        this.openArchiveModal();
      }
    },
  },
  created() {
  },
  mounted() {
    bus.$on("addToArchive", () => {
      this.addToArchive();
    });
  },
  deactivated() {
    this.editorActive = false;
  },
  activated() {
    this.editorActive = true;
  },
  computed: {
    messageLength() {
      var messageCount = this.smsMessage.length;
      if (this.smsMessage.match(/##hotel##/g)) {
        messageCount = messageCount + this.$customerId.length - 9;
      }
      if (this.smsMessage.match(/##roomnumber##/g)) {
        messageCount = messageCount + 3 - 14;
      }
      if (this.smsMessage.match(/##link##/g)) {
        messageCount = messageCount + 56 + this.$hotelId.length - 8;
      }
      return messageCount;
    },
    selectedGuestsWithNumbers() {
      return this.selectedGuestsArray.filter((singleGuest) => {
        if (this.isContactInfoValidOld(singleGuest.phone)) {
          return singleGuest;
        }
      });
    },
    selectedGuestsWithEmails() {
      return this.selectedGuestsArray.filter((singleGuest) => {
        if (this.isEmailValid(singleGuest.email)) {
          return singleGuest;
        }
      });
    },
    manualRoomsList() {
      return this.selectedGuestsArray.map((singleGuest) =>
        parseInt(singleGuest.roomnumber)
      );
    },
    correctMessageContent() {
      return this.messageType === "E-MAIL"
        ? this.emailMessage
        : this.smsMessage;
    },
  },
  methods: {
    sendMultimessage() {
      this.sendingMultiMessages = true;
      const utcTimeStampConverted = this.returnUTCTime();
      const fullUTCYEAR = new Date(utcTimeStampConverted).getFullYear();
      const fullUTCMONTH = new Date(utcTimeStampConverted).getMonth() + 1;
      const formatedDate = new Date(utcTimeStampConverted).toISOString();

      var multimessageDocRef = firestore
        .collection("Multimessage")
        .doc(`${this.$hotelId}`)
        .collection(`${fullUTCYEAR}`)
        .doc(`${fullUTCMONTH}`)
        .collection("multimessages")
        .doc();

      firestore
        .collection("Multimessage")
        .doc(`${this.$hotelId}`)
        .collection(`${fullUTCYEAR}`)
        .doc(`${fullUTCMONTH}`)
        .set(
          {
            lastActivity: utcTimeStampConverted,
          },
          { merge: true }
        );

      const messagesPromiseArray = [];

      if (this.messageType === "SMS") {
        multimessageDocRef.set({
          createdAt: formatedDate,
          messageContent: this.smsMessage,
          sentAmount: this.selectedGuestsWithNumbers.length,
          successfullySent: this.selectedGuestsWithNumbers.length,
          messageType: this.messageType,
        });
        for (let singleGuest of this.selectedGuestsWithNumbers) {
          const messageObj = {};

          messageObj.type = "MULTI-MESSAGE";
          messageObj.media = "sms";
          messageObj.guestname = singleGuest.guestname
            ? singleGuest.guestname
            : "No guest first name";
          messageObj.guestlastname = singleGuest.guestlastname
            ? singleGuest.guestlastname
            : "No guest last name";
          messageObj.roomnumber = singleGuest.roomnumber;
          messageObj.guestID = singleGuest.guestID;
          messageObj.receiverPhone = singleGuest.phone;
          messageObj.message = this.smsMessage;
          messageObj.timestamp = utcTimeStampConverted;
          messageObj.docHash = multimessageDocRef.id;
          messageObj.identification = `Room: ${singleGuest.roomnumber} - ${messageObj.guestname}`;

          let singleMessagePromise = db
            .ref(`messages/${this.$customerId}/${this.$hotelId}/`)
            .push(messageObj)
            .then((snap) => Promise.resolve(snap));
          messagesPromiseArray.push(singleMessagePromise);
        } //End of if messageSMS
      } else if (this.messageType === "E-MAIL") {
        multimessageDocRef.set({
          createdAt: formatedDate,
          messageContent: this.emailMessage,
          sentAmount: this.selectedGuestsWithEmails.length,
          successfullySent: this.selectedGuestsWithEmails.length,
          messageType: this.messageType,
        });

        for (let singleGuest of this.selectedGuestsWithEmails) {
          const messageObj = {};

          messageObj.type = "MULTI-MESSAGE";
          messageObj.media = "email";
          messageObj.guestname = singleGuest.guestname
            ? singleGuest.guestname
            : "No guest first name";
          messageObj.guestlastname = singleGuest.guestlastname
            ? singleGuest.guestlastname
            : "No guest last name";
          messageObj.roomnumber = singleGuest.roomnumber;
          messageObj.guestID = singleGuest.guestID;
          messageObj.receiverEmail = singleGuest.email;
          messageObj.emailSubject = this.emailSubject;
          messageObj.message = this.emailMessage;
          messageObj.timestamp = utcTimeStampConverted;
          messageObj.docHash = multimessageDocRef.id;
          messageObj.identification = `Room: ${singleGuest.roomnumber} - ${messageObj.guestname}`;

          let singleMessagePromise = db
            .ref(`messages/${this.$customerId}/${this.$hotelId}/`)
            .push(messageObj)
            .then((snap) => Promise.resolve(snap));
          messagesPromiseArray.push(singleMessagePromise);
        }
      } //End of if messageEmail

      return Promise.all(messagesPromiseArray).then(() => {
        this.sendingMultiMessages = false;
        this.messageSuccessModal = true;
      });
    },
    addToPermanentArchive() {
      const utcTimeStampConverted = this.returnUTCTime();
      const formatedDate = new Date(utcTimeStampConverted).toISOString();
      firestore.collection("MultimessageArchive").doc(`${this.$hotelId}`).set(
        {
          lastActivity: utcTimeStampConverted,
        },
        { merge: true }
      );

      var archiveMessageRef = firestore
        .collection("MultimessageArchive")
        .doc(`${this.$hotelId}`)
        .collection("ArchivedMessages")
        .doc();

      archiveMessageRef
        .set({
          createdAt: formatedDate,
          messageContent:
            this.messageType === "SMS" ? this.smsMessage : this.emailMessage,
          subjectContent: this.messageType === "SMS" ? null : this.emailSubject,
          messageType: this.messageType,
          documentID: archiveMessageRef.id,
        })
        .then(() => {
          this.$emit("archived", true);
          this.$toastEvents.push({
            type: "positive",
            title: "Success",
            content: "Template has been added!",
            id: +new Date(),
          });
        });
    },
    useContent(payload) {
      if (payload.Type === "SMS") {
        this.messageType = "SMS";
        this.smsMessage = payload.Content;
      } else {
        this.messageType = "E-MAIL";
        this.emailSubject = payload.Subject;
        this.emailMessage = payload.Content;
      }
      this.closeArchiveModal();
      this.$emit("showRoomsSelection");
    },
    closeModal() {
      bus.$emit("closeMultiMessage");
      this.messageSuccessModal = false;
    },
    openArchiveModal() {
      this.showArchive = true;
    },
    closeArchiveModal() {
      this.showArchive = false;
      this.$emit("closeArchiveModal");
    },
    cancelMessageSending() {
      this.showApproveModal = false;
      this.$emit("sendMessageCancel");
    },
    onSelectedImage(imageUrl) {
      this.emailMessage += `<p><img class="responsive" style="display: block; margin-left: auto; margin-right: auto;" src="${imageUrl}" alt="second img"  /></p>`;
    },
    hideToolbar() {
      document.querySelector(".tox-toolbar__overflow").style.display = "none";
    },
    showToolbar() {
      document.querySelector(".tox-toolbar__overflow").style.display = "block";
    },
    schedulderModal() {
      this.$emit("closeScheduler");
    },
    isContactInfoValidOld(contactData) {
      return (
        contactData !== "Blacklisted" &&
        contactData !== "Already in use" &&
        contactData !== "Invalid" &&
        contactData !== "Nothing from PMS" &&
        contactData !== "none" &&
        contactData !== ""
      );
    },
    isEmailValid(emailInput) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; //eslint-disable-line
      return re.test(emailInput);
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
h1,
h2,
h3,
h4,
p {
  color: #707070;
  font-size: 16px;
}
.MessageTemplate {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 25px 25px 10px 25px;
  display: flex;
}
.leftColumn {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}
.sendEmailSmsWrapper,
.smsWrapper {
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.smsWrapper textarea {
  font-family: var(--family);
}
.emailWrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.labelWrap {
  margin-bottom: 15px;
}
.rightColumn {
  display: flex;
  flex-direction: column;
  width: 50%;
}

.charInformation {
  display: flex;
}
.charInformation > p:nth-child(1) {
  margin-right: 15px;
}

.messagesInformatioNWrapper {
  margin-top: 40px;
  justify-content: center;
}
.smsCharInfoWrapper p {
  margin: 0;
}
div.emailSmsMessageWrapper > select {
  width: 250px;
  padding: 8px;
  border: 1px solid #707070;
  border-radius: 5px;
}

.subjectWrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.labelWrap p {
  margin: 5px 0;
  font-weight: bold;
}
.subjectInput {
  width: 100%;
}
.form-control {
  padding: 15px 18px;
  width: 100%;
  color: #66615b;
  border-radius: 8px;
  border: 1px solid #707070;
  border-radius: 4px;
  outline: 0;
  -webkit-transition: 0.3s ease-in;
  transition: 0.3s ease-in;
}
.extendHeight {
  flex-grow: 1; 
}
textarea {
  resize: none;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border: 1px solid #707070;
  border-radius: 5px;
  color: #66615b;
  font-size: 16px;
  padding: 18px;
}
.tinyEditor {
  width: 100%;
  height: 400px;
}
@media screen and (max-width: 1025px) {
  .MessageTemplate {
    padding: 15px 15px 10px 15px;
  }
  .form-control {
    padding: 10px;
  }
  .labelWrap p {
    margin: 0;
    font-size: 14px;
  }
  .sendEmailSmsWrapper,
  .smsWrapper {
    margin-bottom: 10px;
  }
}
@media screen and (max-width: 769px) {
  .MessageTemplate {
    width: 100%;
    height: 100%;
    position: relative;
    padding: 25px 25px 10px 25px;
    display: flex;
    flex-direction: column;
  }
  .sendEmailSmsWrapper {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .sendEmailSmsWrapper > .labelWrap {
    margin-bottom: 0px;
  }
  .hideElement {
    display: none;
  }
  .extendHeight {
    flex-grow: unset;
    height: 100%;
  }
  div.emailSmsMessageWrapper,
  .subjectInput {
    width: 50%;
  }
  div.emailSmsMessageWrapper > select {
    width: 100%;
  }
  .leftColumn {
    flex-grow: unset;
  }
  .rightColumn {
    margin-top: 10px;
    width: 100%;
    height: 100%;
  }
  .sendEmailSmsWrapper {
    margin-bottom: 5px;
  }
  .tinyEditor {
    width: 100%;
    height: 85%;
  }
}
</style>
